<template>
  <span> {{ countdownTime }} </span>
</template>

<script>
let countdownTimer

export default {
  name: 'CountdownTimer',
  components: {},
  props: {
    bookingTime: { type: String, default: '' },
    isGift: { type: Boolean, default: false },
  },
  data() {
    return {
      endTimePeriod: 0,
      countdownText: this.isGift ? this.$t('remaining_time_day', [0]) : `${this.$t('count_down_time', { time: '00:00:00' })}`,
    }
  },
  computed: {
    countdownTime() {
      return this.countdownText
    },
  },
  watch: {
    bookingTime(newDateTime, oldDateTime) {
      this.init(newDateTime)
    },
  },
  mounted() {
    this.init(this.bookingTime)
  },
  methods: {
    init(dateTime) {
      if (dateTime) {
        const timePeriod = this.$dayjs(dateTime).valueOf() - this.$dayjs().valueOf()
        this.endTimePeriod = Math.floor(timePeriod / 1000)
        this.clearInterval()
        this.changeCountdownText()
        this.startCountdownTimer()
      }
    },
    changeCountdownText() {
      let period = this.endTimePeriod
      if (this.endTimePeriod < 0) {
        return this.$t('count_down_time', { time: '00:00:00' })
      }

      let days = 0
      let hours = 0
      let minutes = 0
      let seconds = 0

      // 天
      days = Math.floor(period / 86400)
      period = period % 86400

      // 時
      const hoursText = `0${Math.floor(period / 3600)}`
      hours = hoursText.slice(-2)
      period = period % 3600

      // 分
      const minutesText = `0${Math.floor(period / 60)}`
      minutes = minutesText.slice(-2)
      period = period % 60

      // 秒
      const secondsText = `0${period}`
      seconds = secondsText.slice(-2)

      const countdownTime = `${hours}:${minutes}:${seconds}`

      if (this.isGift) {
        this.countdownText = days
          ? this.$t('remaining_time_day', [days])
          : hours
          ? this.$t('remaining_time_hour', [hours])
          : this.$t('remaining_time_minute', [minutes])
      } else {
        this.countdownText = days
          ? this.$t('count_down_date', { date: days, time: countdownTime })
          : this.$t('count_down_time', { time: countdownTime })
      }
    },
    startCountdownTimer() {
      countdownTimer = window.setInterval(() => {
        if (this.endTimePeriod > 0) {
          this.endTimePeriod -= 1
        } else {
          this.clearInterval()
        }

        this.changeCountdownText()
      }, 1000)
    },
    clearInterval() {
      clearInterval(countdownTimer)
    },
  },
}
</script>
<style lang="scss" scoped></style>
